import React from 'react';
import { withWrapper } from '@shared/react';
import {
    ReserveComputationTableProvider,
    useReserveComputationTable,
    getReserveComputationTableColumns,
    RESERVE_COMPUTATION_TABLE_TITLE,
    RESERVE_COMPUTATION_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import { ReserveComputationTableFilters } from './components';
import './ReserveComputationTable.scss';
import { getReserveComputationTableRows } from './lib/getReserveComputationTableRows';

const ReserveComputationTableContent: React.FC = () => {
    const { dates, onReserveComputationClick } = useReserveComputationTable();

    return (
        <Table
            columns={getReserveComputationTableColumns()}
            data={dates}
            tableTitle={RESERVE_COMPUTATION_TABLE_TITLE}
            infoLink={RESERVE_COMPUTATION_TABLE_INFO_URL}
            filters={<ReserveComputationTableFilters />}
            row={getReserveComputationTableRows({ onReserveComputationClick })}
        />
    );
};

export const ReserveComputationTable = withWrapper(ReserveComputationTableProvider)(ReserveComputationTableContent);
